// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-01-13T09:44:35Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 *  Generated from cz.marbes.eosp.controller.ReCaptchaController.
 */
export default class ReCaptchaApi {
    /**
     * Vrátí sitekey pro reCAPTCHA v případě, že je reCAPTCHA pro daného klienta vyžadována. @return sitekey nebo {@code null} pokud není reCAPTCHA vyžadována
     *
     * @return java.lang.String
     */
    static getReCaptchaSiteKey() {
        const uri = serverContextPath + `/api/recaptcha/site-key`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
